// For new features, use sectorsApi slice. In the future we might deprecate this module.

import api from './api';

const listSectors = query => api.get('/api/sectors/', { params: query });

const fetchSector = sectorId => api.get(`/api/sectors/${sectorId}/`);

export default { listSectors, fetchSector };
